import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';
import _ from 'lodash';

import {updateReconciliationRisk} from '../../../../actions/Reconciliations';

import {currentResource, labels} from '../../../../util/utils';

import selectComponentRisks from '../../../../reducers/Reconciliations/selectors/selectComponentRisks';

import Modal from '../../../CoreWrappers/Modal';
import useForm from '../../../CoreWrappers/Form/useForm';

import StyledRelateRisksModal from './StyledRelateRisksModal';
import ComponentRiskTable from './ComponentRiskTable';
import selectProjectAndEngIds from '../../../../reducers/Reconciliations/selectors/selectProjectAndEngIds';
import RiskTypeAbbreviationDisplay from '../../RiskTypeAbbreviationDisplay';

const RISK_TABLE = 'riskTable';
const SELECTED_RISK = 'selectedRisk';

const RelateRisksModal = ({primaryRisk, show = false, setShow = null}) => {
	const [isLoading, setIsLoading] = useState([]);

	const riskList = selectComponentRisks();
	const apiConfig = selectProjectAndEngIds();

	const dispatch = useDispatch();

	const onHide = () => {
		setIsLoading([]);
		setShow && setShow(false);
	};

	const handleSetIsLoading = (id, add = false) => {
		let newValue = [];
		if (add) newValue = [...isLoading, id];
		else isLoading.filter((oldId) => oldId !== id);
		setIsLoading([...newValue]);
	};

	const initialValues = {
		[RISK_TABLE]:
			riskList
				.filter((cr) => cr?.relatedComponentRisks?.some((rcr) => rcr?.primaryRiskId === primaryRisk?.riskId))
				?.map((r) => r?.riskId) ?? [],
		[SELECTED_RISK]: []
	};

	const schema = {
		[RISK_TABLE]: {required: false},
		[SELECTED_RISK]: {required: false},
	};

	const {values, errors, handleChange, handleSubmit, handleReset, isFormValid} = useForm({
		initialValues,
		schema,
		onChange: (values, revertChange) => {
			let selectedRisk = values[SELECTED_RISK];	
			let componentRisksToAdd = [];	let componentRisksToRemove = [];	
			if(selectedRisk?.isAdded) {
				componentRisksToAdd = selectedRisk.id
			} else {
				componentRisksToRemove = selectedRisk.id;
			}
			const payload = {
				RelatedComponentRisks: {componentRisksToAdd, componentRisksToRemove}
			};

			setIsLoading([...componentRisksToAdd, ...componentRisksToRemove]);
			dispatch(updateReconciliationRisk(primaryRisk.riskId, payload, apiConfig))
			.then(() => handleSetIsLoading(selectedRisk.id[0]))
				.catch(() => {
					handleSetIsLoading(selectedRisk.id[0]);
					revertChange()
				});
		},
		labels: currentResource.formLabels
	});

	const renderInstructional = () => (
		<OutputText light className="full">
			{labels.relateRisksModalInstructionalText}
		</OutputText>
	);

	const renderLabel = () => (
		<div className="full label-name">
			<OutputText light>{labels.primaryRegionTeamRisk}</OutputText>
			<RiskTypeAbbreviationDisplay id={primaryRisk.riskTypeId}/>
			<OutputText regular ellipsis multilineEllipsis={2} title={primaryRisk.riskName}>
				{primaryRisk.riskName}
			</OutputText>
		</div>
	);

	const renderTable = () => {
		const id = RISK_TABLE;

		const OnSelectionChange = (id, newValue, selectedRisk) => {
			if(newValue?.includes(selectedRisk)){
				handleChange(id, newValue,  {[SELECTED_RISK]: {id : [selectedRisk], isAdded: true } });
			}else{
				handleChange(id, newValue, {[SELECTED_RISK]: {id : [selectedRisk], isAdded: false } });
			}			
		}

		const props = {
			id,
			primaryRiskId: primaryRisk.riskId,
			value: values[id],
			onChange: (newValue, selectedRisk) => OnSelectionChange(id, newValue, selectedRisk),
			isLoading
		};

		if (errors[id]) props.errorMessage = errors[id]?.message;

		return (
			<div className="full">
				<ComponentRiskTable {...props} />
			</div>
		);
	};

	const props = {
		show,
		modalsize: 'medium',
		title: labels.relateRisksModalTitle,
		labels: {
			modalConfirmBtnLabel: labels.save,
			modalCancelBtnLabel: labels.cancelLabel,
			modalCloseBtnTitletip: labels.closeLabel
		},
		onClose: () => {
			handleReset();
			onHide();
		},
		showFooter: false,
		disableClose: isLoading.length > 0,
	};

	return (
		show && (
			<Modal {...props}>
				<StyledRelateRisksModal>
					{renderInstructional()}
					{renderLabel()}
					{renderTable()}
				</StyledRelateRisksModal>
			</Modal>
		)
	);
};

RelateRisksModal.propTypes = {};

export default RelateRisksModal;
